// extracted by mini-css-extract-plugin
export default {"ErrorBoundary":"ErrorBoundary_ErrorBoundary__IuTDp","ErrorBoundary__Reload":"ErrorBoundary_ErrorBoundary__Reload__EXOQb"};